import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const apiUrl = import.meta.env.VITE_API_URL ?? '/api/v5';
const emailApi = apiUrl.replace(/\/v5\/?$/, '') + '/v5/email';

export default function EmailViewPage() {
  const [searchParams] = useSearchParams();
  const data = searchParams.get('data') ?? '';

  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!data) {
      setError('Invalid link.');
      return;
    }

    (async () => {
      try {
        const res = await axios.get(`${emailApi}/view`, {
          params: { data },
          responseType: 'text',
          headers: { Accept: 'text/html' },
        });
        setHtml(res.data);
      } catch (err: any) {
        const status = err?.response?.status;
        if (status === 403) {
          setError('This link is invalid or has expired.');
        } else if (status === 404) {
          setError('This email could not be found or is no longer available.');
        } else {
          setError('An error occurred while loading the email.');
        }
      }
    })();
  }, [data]);

  if (error) {
    return (
      <div style={{ fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif", background: '#f5f7fa', color: '#333', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,.08)', maxWidth: 480, width: '100%', margin: 20, padding: '48px 40px', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: 28, background: '#fce4ec', color: '#c62828' }}>&#10007;</div>
          <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 12, color: '#1a1a1a' }}>Unable to Display Email</h1>
          <p style={{ fontSize: 15, color: '#555', lineHeight: 1.6 }}>{error}</p>
        </div>
      </div>
    );
  }

  if (html === null) {
    return null;
  }

  const safeHtml = html.replace(
    /(<head[^>]*>)/i,
    '$1<base target="_blank" />',
  );

  return (
    <iframe
      srcDoc={safeHtml}
      title="Email content"
      style={{ width: '100%', height: '100vh', border: 'none' }}
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    />
  );
}
